import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import MlsServiceLogRepository from "~/repository/MlsService/MlsServiceLogRepository";
import MlsServiceLog from "../../models/MlsService/MlsServiceLog";

class MlsServiceLogStore extends NestStore {
  rootStore = null;

  /**
   * @property {Array}
   */
  @observable mlsServiceLogs = [];

  /**
   * @property {Object|null}
   */
  @observable mlsServiceLog = null;

  /**
   * @property {number|null}
   */
  @observable mlsServiceLogId = null;

  /**
   * @property {MlsServiceLogRepository|null}
   */
  mlsServiceLogRepository = null;

  constructor(rootStore) {
    super();

    this.rootStore = rootStore;

    this.mlsServiceLogRepository = new MlsServiceLogRepository();

    this.setDefaultSearchParams();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getOne()]).finally(() => {
      this.isLoading = false;
    });
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
    };

    if (this.searchParams.tourId !== "") {
      params.tourId = this.searchParams.tourId;
    }

    return this.mlsServiceLogRepository.fetch(params).then(response => {
      this.processEntities(response.data.mlsServiceLogs);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(mlsServiceLogs = []) {
    this.mlsServiceLogs = [];

    mlsServiceLogs.forEach(mlsServiceLogArray => {
      const mlsServiceLog = new MlsServiceLog(mlsServiceLogArray);

      this.mlsServiceLogs.push(mlsServiceLog);
    });
  }

  @action
  getOne() {
    return this.mlsServiceLogRepository.fetchOne(this.mlsServiceLogId).then(response => {
      this.mlsServiceLog = new MlsServiceLog(response.data.mlsServiceLog);
    });
  }

  /**
   * Change the pagination page and fetch the Mls Service Logs.
   */
  @action
  changePage(page) {
    this.pagination.currentPage = page;

    return this.loadIndex();
  }

  /**
   * Change the pagination page and fetch the Mls Service Logs.
   */
  @action
  search() {
    this.pagination.currentPage = 1;

    return this.loadIndex();
  }

  /**
   * Set default search params.
   */
  @action
  setDefaultSearchParams() {
    this.searchParams.tourId = "";
  }
}

export default MlsServiceLogStore;
